import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Sliders.css";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function SliderPrevArrow({ onClick }) {
  return (
    <button
      type="button"
      className="slider-toggle-arrow slider-toggle-prev"
      onClick={onClick}
      aria-label="Previous slide"
    >
      <FaChevronLeft />
    </button>
  );
}

function SliderNextArrow({ onClick }) {
  return (
    <button
      type="button"
      className="slider-toggle-arrow slider-toggle-next"
      onClick={onClick}
      aria-label="Next slide"
    >
      <FaChevronRight />
    </button>
  );
}

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  adaptiveHeight: true,
  arrows: true,
  prevArrow: <SliderPrevArrow />,
  nextArrow: <SliderNextArrow />,
  centerMode: false,
};
function Sliders() {
  const [sliders, setSliders] = useState([]);
  const baseURL = "https://karstar.in/";
  useEffect(() => {
    getSliders();
  }, []);

  const getSliders = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/api/client_api/Sliders/index.php`
      );
      setSliders(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const generateSlug = (name) => {
    return (name || "")
      .toString()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  };

  const getSliderLink = (item) => {
    if (!item) return "/";
    if (item.slider_type === "promotion") {
      return "/";
    }
    if (item.slider_type === "product") {
      const prod = item.additional_data?.product;
      return prod ? `/product/${generateSlug(prod)}` : "/products";
    }
    const col = item.additional_data?.collection;
    return col ? `/collections/${generateSlug(col)}` : "/collections";
  };

  const priority = [
    "All Products",
    "Instant Geysers",
    "Portable Washing Machine",
    "Semi Automatic washing Machine",
    "High Pressure Washers",
    "Vaccum Cleaners",
    "Water Pumps",
    "Mixers and Wet Grinders",
    "Gas Stoves",
    "Chimneys",
    "Air coolers",
    "Shoe Racks",
    "Korai Mat",
    "Sofa cum Beds",
  ];

  const sortedSliders = [...sliders].sort((a, b) => {
    // 1. Handle promotions first (slider_type === 'promotion')
    if (a.slider_type === "promotion" && b.slider_type !== "promotion")
      return -1;
    if (a.slider_type !== "promotion" && b.slider_type === "promotion")
      return 1;
    if (a.slider_type === "promotion" && b.slider_type === "promotion")
      return 0;

    // 2. Handle product items (slider_type === 'product') should come second
    if (a.slider_type === "product" && b.slider_type !== "product")
      return -1;
    if (a.slider_type !== "product" && b.slider_type === "product")
      return 1;
    if (a.slider_type === "product" && b.slider_type === "product") {
      const aProd = a.additional_data?.product || "";
      const bProd = b.additional_data?.product || "";
      return aProd.localeCompare(bProd);
    }

    // 3. Now sort by collection name, using priority for predefined collections
    const aCollection = a.additional_data?.collection || "";
    const bCollection = b.additional_data?.collection || "";

    const aPriority = priority.indexOf(aCollection);
    const bPriority = priority.indexOf(bCollection);

    // Prioritize the categories in the priority array
    if (aPriority !== -1 && bPriority !== -1) {
      return aPriority - bPriority;
    }
    if (aPriority !== -1) return -1; // a has priority
    if (bPriority !== -1) return 1; // b has priority

    // Default alphabetical sorting for others
    return aCollection.localeCompare(bCollection);
  });

  return (
    <div>
      <section>
        <div className="sliderDesktop mt-3">
          <Container>
            <Slider {...sliderSettings}>
              {sortedSliders.length > 0 ? (
                sortedSliders.map((item, index) => {
                  const linkUrl = getSliderLink(item);
                  return (
                    <Link to={linkUrl} key={index} className="slide-item">
                      <img
                        src={baseURL + item.image_path}
                        alt="Slide"
                        className="sliderImages"
                      />
                    </Link>
                  );
                })
              ) : (
                <Skeleton
                  height={500}
                  className="mr-2 slide-item"
                  style={{
                    width: "100%",
                    paddingBottom: "45.45%", // This keeps the aspect ratio as 2.20:1 (width:height)
                    position: "relative",
                  }}
                />
              )}
            </Slider>
          </Container>
        </div>
        <div className="sliderMobile">
          {sortedSliders.length > 0 ? (
            <Slider {...sliderSettings}>
              {sortedSliders.map((item, index) => (
                <Link
                  to={getSliderLink(item)}
                  key={index}
                  className="slide-item"
                >
                  <img
                    src={baseURL + item.mobile_image_path}
                    alt="Slide 1"
                    className="sliderImages"
                  />
                </Link>
              ))}
            </Slider>
          ) : (
            <Skeleton height={200} style={{ width: "95%" }} className="mx-2" />
          )}
        </div>
      </section>
    </div>
  );
}

export default Sliders;
